import { configureStore } from "@reduxjs/toolkit";
import SubscriptionPlans_Slice from "./redux/Slice/SubscriptionPlans_Slice";
import FaqSlice from "./redux/Slice/FaqSlice";
import TermsAndConditionsSlice from './redux/Slice/TermAndConditionSlice'
import PrivecyPolicysSlice from "./redux/Slice/PrivecyPolicysSlice";
import AuthSlice from "./redux/Slice/AuthSlice";
import FolderSlice from "./redux/Slice/FoldersSlice";
import FileSlice from "./redux/Slice/FlieSlice";
import UserSlice from "./redux/Slice/UserSlice";
import FoldersSlice from "./redux/Slice/FoldersSlice";

const store = configureStore({

    reducer: {
        auth: AuthSlice,
        user: UserSlice,
        subscription: SubscriptionPlans_Slice,
        faq: FaqSlice,
        TermsAndConditions: TermsAndConditionsSlice,
        PrivecyPolicys: PrivecyPolicysSlice,
        Folder: FolderSlice,
        File: FileSlice,
        folders: FoldersSlice,

    },

})
export default store